"use client";

import type { KnopkaBookingPageAppearance } from "../knopkaBookingPageAppearance";

export function KnopkaBookingPageBackground({ active }: { active: boolean }) {
  if (!active) return null;

  return (
    <>
      <div aria-hidden className="knopka-tg-bg-layer pointer-events-none fixed inset-0 -z-10" />
      <div aria-hidden className="knopka-tg-bg-overlay pointer-events-none fixed inset-0 -z-[9]" />
    </>
  );
}

export function KnopkaBookingPageBackgroundPreview({
  appearance,
}: {
  appearance: Pick<KnopkaBookingPageAppearance, "backgroundUrl">;
}) {
  if (!appearance.backgroundUrl.trim()) return null;
  return (
    <div
      className="knopka-bg-preview mb-3"
      style={{ backgroundImage: `url("${appearance.backgroundUrl.trim().replace(/"/g, "")}")` }}
      aria-hidden
    />
  );
}
